import type { IconKind } from '../data/forms.js';

interface RectSpec {
  x: number;
  y: number;
  w: number;
  h: number;
  rx: number;
  soft?: boolean;
}

const SHAPES: Record<IconKind, RectSpec[]> = {
  grid: [
    { x: 3, y: 3, w: 8, h: 8, rx: 2, soft: true },
    { x: 13, y: 3, w: 8, h: 8, rx: 2 },
    { x: 3, y: 13, w: 8, h: 8, rx: 2 },
    { x: 13, y: 13, w: 8, h: 8, rx: 2, soft: true },
  ],
  doc: [
    { x: 4, y: 2.5, w: 16, h: 19, rx: 2.5, soft: true },
    { x: 7.5, y: 7, w: 9, h: 1.8, rx: 0.9 },
    { x: 7.5, y: 11.1, w: 9, h: 1.8, rx: 0.9 },
    { x: 7.5, y: 15.2, w: 5.5, h: 1.8, rx: 0.9 },
  ],
  user: [{ x: 4.6, y: 13.6, w: 14.8, h: 7.6, rx: 3.8, soft: true }],
  // Three bars of different heights: figures over a period.
  chart: [
    { x: 4, y: 13, w: 4, h: 8, rx: 1.4, soft: true },
    { x: 10, y: 8.5, w: 4, h: 12.5, rx: 1.4 },
    { x: 16, y: 4, w: 4, h: 17, rx: 1.4, soft: true },
  ],
  box: [{ x: 9.4, y: 9.4, w: 5.2, h: 5.2, rx: 1.4 }],
  // A card with its stripe and a short number: how the money arrived.
  card: [
    { x: 3, y: 5.5, w: 18, h: 13, rx: 2.4, soft: true },
    { x: 3, y: 9.2, w: 18, h: 2.3, rx: 0 },
    { x: 6.2, y: 14.2, w: 5.4, h: 1.8, rx: 0.9 },
  ],
  plug: [
    { x: 5.5, y: 9, w: 13, h: 8.5, rx: 2.5, soft: true },
    { x: 9, y: 2.6, w: 2.2, h: 5.6, rx: 1.1 },
    { x: 12.8, y: 2.6, w: 2.2, h: 5.6, rx: 1.1 },
    { x: 10.9, y: 17.4, w: 2.2, h: 4, rx: 1.1 },
  ],
};

export function Icon({ kind, color, size = 16 }: { kind: IconKind; color: string; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      {kind === 'user' && <circle cx={12} cy={7.6} r={3.9} fill={color} />}
      {kind === 'box' && (
        <path d="M12 2.4l9 5.1v9.9l-9 5.1-9-5.1V7.5z" fill={color} opacity={0.26} />
      )}
      {SHAPES[kind].map((r) => (
        <rect
          key={`${r.x}-${r.y}-${r.w}`}
          x={r.x}
          y={r.y}
          width={r.w}
          height={r.h}
          rx={r.rx}
          fill={color}
          opacity={r.soft ? 0.26 : 1}
        />
      ))}
    </svg>
  );
}
